import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import PageTitle from './PageTitle';
import ErrorDisplay from './ErrorDisplay';
import Waiting from './Waiting';

import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import RoomIcon from '@mui/icons-material/Room';
import PhoneIcon from '@mui/icons-material/Phone';
import ComputerIcon from '@mui/icons-material/Computer';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import SvgIcon from '@mui/material/SvgIcon';

import Typography from '@mui/material/Typography';

import clsx from 'clsx';
import useStyles from '../styles/Styles'

import { loadSettings } from '../actions';

import {ReactComponent as U3AIcon} from '../styles/U3AIcon2.svg';

import _ from 'lodash';

const Contact = () => {
	const classes = useStyles();
	
	const contact = useSelector(state => state.settings.contact.data);
	const courseLabels = useSelector(state => state.settings.labels_courses.data);
	const fetchingContact = useSelector(state => state.settings.fetching_contact);
	const dispatch = useDispatch();
	const init = useSelector(state => state.requests.init);
	
	const names_map = {
		formal_name: {title: "Organisation", icon: <SvgIcon component={U3AIcon} /> },
		general_email: { title: "General email", link: { href: "mailto:" }, icon: <AlternateEmailIcon />},
		courses_email: { title: courseLabels.coursesCapLabel + " email", link: { href: "mailto:" }, icon: <AlternateEmailIcon /> },
		volunteer_email: { title: "Volunteers email", link: { href: "mailto:" }, icon: <AlternateEmailIcon /> },
		phone: { title: "Phone", icon: <PhoneIcon />},
		address: { title: "Address", icon: <RoomIcon />},
		office_hours: { title: "Office hours", icon: <QueryBuilderIcon />},
		website: { title: "Website", link: {href: "", target: "_blank"}, icon: <ComputerIcon />},
		postal_address: { title: "Postal address", icon: <LocalPostOfficeIcon />},
	};
	
	useEffect(() => {  
		if(!init){
			return;
		}
		dispatch(loadSettings('contact'));
	}, [dispatch, init]);
	
	const displayable = _.chain(contact).omitBy(_.isEmpty).map(function(v, k){
		return _.merge({value: v, key:k}, names_map[k]);
	}).value();
	
	const ListOutput = (props) => {
		if(props.item.link){
			props.item.link.href = props.item.link.href + props.item.value;
		}
		const secondary = props.item.link ? 
		<a {...props.item.link}>{props.item.value}</a>
		: props.item.value;
		
		return (
		<ListItem>
		<ListItemAvatar>
          <Avatar>
            {props.item.icon ? <>{props.item.icon}</> : null}
          </Avatar>
        </ListItemAvatar>
		
		<ListItemText color="primary"
			primary={props.item.title}
			secondary={secondary}
			/>
		</ListItem>
	)}
	
	return (
	<>
	
	<ErrorDisplay />
	<Paper className={clsx(classes.innerContent, classes.page)} square={true}>
	<PageTitle title='Contact Us' />
		{fetchingContact ? 
		<Waiting 
			message='Fetching contact details. Please wait...'
		/> :
		<List className={classes.contentList} >
		<ListSubheader disableSticky>
		<Typography variant="h6">
        {contact.display_name}
		</Typography>
		</ListSubheader>
		{displayable.map((d, i) => (
			d.title ? <ListOutput item={d} key={i} /> : null
		))}
		</List>
	
	}
	</Paper >
	</>
)};

export default Contact
